<div id="userInfo">
    <app-lang></app-lang>
    <div class="userInfo">
        <div class="user cursor" nz-dropdown [nzDropdownMenu]="menu" *ngIf="!isMobile">
            <div class="userImage mr10">
                <img  src="{{ img ? img :'../../../assets/img/man.png'}}" alt="{{basicInfo.displayName}}">
            </div>
            <div class="info">
                <div class="userName">{{basicInfo.displayName}}</div>
                <div class="userEmail">{{basicInfo.mail?basicInfo.mail : 'empty'}}</div>
            </div>

        </div>
        <span nz-icon nzType="menu" nzTheme="outline" nz-dropdown [nzDropdownMenu]="menu" *ngIf="isMobile"></span>
        <nz-dropdown-menu #menu="nzDropdownMenu" class= "menuItem" >
            <ul nz-menu class="w355">
                <li nz-menu-item class="li-hover" >
                    <div>
                        <div class="user cursor-default p30">
                            <div class="userImage mr10">
                                <img src="{{ img ? img :'../../../assets/img/man.png'}}" alt="{{basicInfo.displayName}}">
                            </div>
                            <div class="info">
                                <div class="userName">{{basicInfo.displayName}}</div>
                                <div class="userEmail maxw180" nzTooltipTitle="{{basicInfo.mail}}"  nzTooltipPlacement="bottom" nz-tooltip>{{basicInfo.mail?basicInfo.mail : 'empty'}}</div>
                            </div>
                        </div>
                        <div class="service cursor-default ml30">
                            {{'appName' | translate }}
                        </div>
                    </div>
                </li>
                <li nz-menu-item (click)="gotoAdminPage()" class="font h44" *ngIf="isShowRole && isMobile && isInquiry"><span class="ml30">{{'menu.adminPage' | translate}}</span></li>
                <li nz-menu-item (click)="backtoInquiry()" class="font h44" *ngIf="isShowRole && isMobile && !isInquiry"><span class="ml30">{{'button.backToTicket' | translate}}</span></li>
                <li nz-menu-item (click)="gotoAdminPage()" class="font h44" *ngIf="isShowRole && isMobile && !isInquiry"><span class="ml30">{{'category.category' | translate}}</span></li>
                <li nz-menu-item (click)="gotoSubCategoyPage()" class="font h44" *ngIf="isShowRole && isMobile && !isInquiry"><span class="ml30">{{'subCategory.subCategory' | translate}}</span></li>
                <li nz-menu-item (click)="gotoSupportTeamPage()" class="font h44" *ngIf="isShowRole && isMobile && !isInquiry"><span class="ml30">{{'supportTeam.supportTeam' | translate}}</span></li>
                
                <!-- Authentication Debug Section -->
                <li nz-menu-divider></li>
                <li nz-menu-item (click)="toggleTokenDisplay()" class="font h44">
                    <span class="ml30">
                        🔐 Debug: {{ showTokens ? 'Hide' : 'Show' }} JWT Tokens
                    </span>
                </li>
                <li nz-menu-item (click)="resetAuthentication()" class="font h44">
                    <span class="ml30">
                        🔄 Reset Authentication (Fix Login Issues)
                    </span>
                </li>
                
                <!-- Token Information Display -->
                <li nz-menu-item *ngIf="showTokens" class="token-info-section">
                    <div class="ml30 token-debug">
                        <div class="token-title">🎯 <strong>JWT Token Information</strong></div>
                        
                        <!-- Access Token -->
                        <div class="token-section">
                            <div class="token-label">🔑 Access Token:</div>
                            <div class="token-value" [title]="tokenInfo.accessToken || 'Not available'">
                                {{ getTruncatedToken(tokenInfo.accessToken, 60) }}
                            </div>
                            <button *ngIf="tokenInfo.accessToken" 
                                    (click)="copyTokenToClipboard('access')" 
                                    class="copy-btn">
                                📋 Copy
                            </button>
                        </div>
                        
                        <!-- ID Token -->
                        <div class="token-section">
                            <div class="token-label">🆔 ID Token:</div>
                            <div class="token-value" [title]="tokenInfo.idToken || 'Not available'">
                                {{ getTruncatedToken(tokenInfo.idToken, 60) }}
                            </div>
                            <button *ngIf="tokenInfo.idToken" 
                                    (click)="copyTokenToClipboard('id')" 
                                    class="copy-btn">
                                📋 Copy
                            </button>
                        </div>
                        
                        <!-- Account Info -->
                        <div class="token-section">
                            <div class="token-label">👤 Account:</div>
                            <div class="token-value">{{ tokenInfo.account?.username || 'Not available' }}</div>
                        </div>
                        
                        <!-- Token Expiry -->
                        <div class="token-section">
                            <div class="token-label">⏰ Expiry:</div>
                            <div class="token-value">{{ tokenInfo.tokenExpiry || 'Not available' }}</div>
                        </div>
                    </div>
                </li>
                
                <li nz-menu-divider *ngIf="showTokens"></li>
                <li nz-menu-item (click)="logout()" class="font mb10 h44"><span class="ml30">{{'user.logout' | translate }}</span></li>
            </ul>
        </nz-dropdown-menu>
    </div>
</div>